import { useEffect } from 'react'
import { useParams } from 'react-router'
import PageMeta from '../../../components/common/PageMeta'
import { useCompany } from '../../../context/CompanyContext'
import CompanyResume from './CompanyResume'
import { CompanyTabs } from './Tabs/CompanyTabs'

const CompanyDetail = () => {
    const { id } = useParams<{ id: string }>()
    const { getCompany } = useCompany()

    useEffect(() => {
        if (!id) return
        getCompany(id)
    }, [id])

    return (
        <>
            <PageMeta title='Empresa | CRM' description='Dados da empresa' />
            <div className='space-y-4'>
                <CompanyResume />
                <CompanyTabs />
            </div>
        </>
    )
}

export default CompanyDetail
